<h2 class="text-center" *ngIf="showTitle">Selecciona un Email para iniciar sesión</h2>
<article class="form-wrapper" *ngIf="!enableValidateCode">
  <section>
    <div class="container-options">
      <div class="option" *ngFor="let option of options">
        <label class="container-checked">
          <input type="radio" (change)="selectOption(option)" name="radio">
          <span class="checkmark"></span>
        </label>
        <img class="img" [src]="'./../../../../assets/svg/mail-modal.svg'" alt="">
        <div>
          <p class="data-option"><strong>{{option}}</strong></p>
        </div>
      </div>
    </div>
  </section>
  <section class="container-button">
    <app-button [title]="'Enviar código'"
      [isDisabled]="disableButton" [customClasses]="'main full-width sign-up-button'" [isLoading]="isLoading"
      (click)="openValidateCode()"></app-button>
  </section>
</article>

<app-validate-code *ngIf="isModal && enableValidateCode" [from]="'select'" [customer]="customer" (validateCode)="onValidateCode($event)" (loggedIn)="onSuccess($event)"></app-validate-code>
